module.exports = __webpack_public_path__ + "img/load1.93ef9259.jpg";